export default __webpack_public_path__ + "static/media/illustrazione.9a866cf2.jpg";